import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLang } from '../i18n/LanguageContext';
import { CLIENTS } from '../data/clientsData';
import styles from './Clients.module.css';

function ClientMark({ name, since, sinceLabel }) {
  return (
    <div className={styles.mark}>
      <span className={styles.name}>{name}</span>
      <span className={styles.since}>{sinceLabel} {since}</span>
    </div>
  );
}

export default function Clients() {
  const revealRef = useScrollReveal();
  const { t } = useLang();
  const track = [...CLIENTS, ...CLIENTS];

  return (
    <section className={styles.section} aria-label={t('clients.eyebrow')}>
      <div className={`container reveal ${styles.header}`} ref={revealRef}>
        <p className={styles.eyebrow}><span className={styles.dot} aria-hidden="true" />{t('clients.eyebrow')}</p>
        <h2 className={styles.heading}>
          {t('clients.eyebrow') === 'Trusted by'
            ? 'Teams who keep us on speed dial'
            : 'Teams, die uns auf Speeddial haben'}
        </h2>
      </div>

      <div className={styles.marqueeWrap}>
        <div className={styles.fadeLeft} aria-hidden="true" />
        <div className={styles.fadeRight} aria-hidden="true" />

        <div className={styles.marquee}>
          <ul className={styles.track} aria-hidden="true">
            {track.map((client, i) => (
              <li key={`${client.slug}-${i}`} className={styles.item}>
                <ClientMark name={client.name} since={client.since} sinceLabel={t('clients.since')} />
              </li>
            ))}
          </ul>
        </div>

        <p className={styles.srOnly}>
          {CLIENTS.map((c) => `${c.name}, ${t('clients.since')} ${c.since}`).join('; ')}
        </p>
      </div>
    </section>
  );
}
